/***************************************************************
12/07/2018
Alexander Self
Mech harvest table
- Table summary of harvest: mech or hand
***************************************************************/
import { sumProp, avgProp } from '../../../../harvest_utils';
import React from 'react';

const HarvestEquipmentTable = ({ harvest, totals }) => {
  if (!harvest) return <span></span>;

  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th>Key</th>
          <th>Total Containers</th>
          <th>Total Lbs</th>
          <th>Total Trees</th>
          <th>Total Hours</th>
          <th>Total Cost</th>
          <th>Lbs / Hr</th>
          <th>Cost / Lb</th>
          <th>Density</th>
          <th>Acres/Hr</th>
        </tr>
      </thead>
      <tbody>
        {
          harvest.map((h) => {
            return (
              <tr key={h.key}>
                <td>{ h.key }</td>
                <td>{ h.totalContainers }</td>
                <td>{ h.totalLbs } lbs</td>
                <td>{ h.totalTrees }</td>
                <td>{ h.totalHours }</td>
                <td>${ h.totalCost }</td>
                <td>{ h.avgLbsPerHour }</td>
                <td>${ h.avgCostPerLb }</td>
                <td>{ h.avgDensity } lbs/tree</td>
                <td>{ h.avgAcresPerHour }</td>
              </tr>
            )
          })
        }
      </tbody>
      { totals ?
        <tfoot>
          <tr>
            <td></td>
            <td><center><b>{ sumProp('totalContainers', harvest) }</b></center></td>
            <td><center><b>{ sumProp('totalLbs', harvest) } lbs</b></center></td>
            <td><center><b>{ sumProp('totalTrees', harvest) }</b></center></td>
            <td><center><b>{ sumProp('totalHours', harvest) }</b></center></td>
            <td><center><b>${ sumProp('totalCost', harvest) }</b></center></td>
            <td><center><b>{ avgProp('avgLbsPerHour', harvest) }</b></center></td>
            <td><center><b>${ avgProp('avgCostPerLb', harvest) }</b></center></td>
            <td><center><b>{ avgProp('avgDensity', harvest) } lbs/tree</b></center></td>
            <td><center><b>{ avgProp('avgAcresPerHour', harvest) }</b></center></td>
          </tr>
        </tfoot>
        : <tfoot></tfoot>
      }

    </table>
  );
};

export default HarvestEquipmentTable;



// WEBPACK FOOTER //
// ./src/components/harvest/view/report/harvest_equipment_table.jsx